import Imgix from 'react-imgix';
import { IListItem } from '../../list-page/interfaces/interfaces';
import { sendGAListPageEvent } from '../../../domain/marketing/gtm-provider';
import { CSSProperties } from 'react';

interface IProductImageProps {
    product: IListItem,
    removeImgLink?: boolean,
    style?: CSSProperties,
    classes?: string,
    listName?: string,
    imageHeight?: string,
}

/**
 * Product image.
 * https://docs.imgix.com/libraries/react-imgix#lazy-loading
 */
const ProductImage = (props: IProductImageProps) => {

    const product = props.product;

    /*auto height (defaulr = 150)*/
    let height : any = 150;
    let autoHeightCss = 'px-4 bg-gray-100';

    if(props?.imageHeight) {
        autoHeightCss = '';

        if(props?.imageHeight === 'auto')
            height = undefined
        else
            height = props?.imageHeight;
    }


    const getImage = () => {
        return (
            product.thumb ?
            <Imgix
                className="lazyload"
                src={ product.thumb }
                height={ height }
                attributeConfig={{
                    src: 'data-src',
                    srcSet: 'data-srcset',
                    sizes: 'data-sizes',
                }}
                htmlAttributes={{
                    alt: `Image for ${ product.documentName }`
                }}
                disableQualityByDPR
            /> : <div />
        )
    };

    const getBadge = () => {
        return <div className={ `text-sm text-center text-white absolute px-4 py-1 left-0 bottom-0 ${ product.badgeClass }` }>{ product.badgeText }</div>    ;
    };

    return (
        <>
            {
                props.removeImgLink && (
                    <div
                        className={`${autoHeightCss} flex justify-center items-center relative ${ props.classes }`}
                        title={ product.documentName }
                        style={ props.style }>
                        { getImage() }
                        { product.badgeText && getBadge() }
                    </div>
                )
            }

            {
                !props.removeImgLink &&
                <a
                    href={ product.documentUrlPath }
                    className={`${autoHeightCss} flex justify-center items-center relative ${ props.classes }`}
                    title={ product.documentName }
                    style={ props.style }
                    onClick={evt => {
                        sendGAListPageEvent(product, props.listName);
                    }}>

                    { getImage() }
                    { product.badgeText && getBadge() }
                </a>
            }
        </>
    )
};

export default ProductImage;